// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"11de8d19","453":"52026a02","963":"9d11278d"}[chunkId] + ".chunk.js";
};